import { Injectable } from '@angular/core';

export interface DefaultDateKeys {
  createdAt_gte?: string;
  createdAt_lte?: string;
}

@Injectable({
  providedIn: 'root'
})
export class ReportsMapperService {

  constructor() { }

  public equalizeFilterQueryParams(queryParams): DefaultDateKeys {
    const initialDate = ['createdAt_gte', 'completedAt_gte'];
    const finalDate = ['createdAt_lte', 'completedAt_lte'];
    const equaledParameters = {};

    for (const parameter of Object.keys(queryParams)) {
      if (initialDate.includes(parameter)) {
        equaledParameters['createdAt_gte'] = queryParams[parameter];
      }

      if (finalDate.includes(parameter)) {
        equaledParameters['createdAt_lte'] = queryParams[parameter];
      }
    }

    return equaledParameters;
  }
}
